import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewNoteCategory from "./NewNoteCategory";
import ListNoteCategory from "./ListNoteCategory";
import UpdateNoteCategory from "./UpdateNoteForm";
import {
	NEW_NOTE_ITEM,
	GET_LIST,
	UPDATE_NOTE_ITEM,
	REMOVE
} from "../../../queries/noteCategory.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../providers/Auth.Provider";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import { Redirect } from "react-router-dom";

const NoteCategory = ({ match, location }) => {
	// local state
	const [newNote, setNewNote] = useState(false);
	const [noteCategory, setNoteCategory] = useState(null);

	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// query
	const { loading, data, error } = useQuery(GET_LIST, {
		variables: { site: site && site.id }
	});
	// Mutation
	const [
		CreateCategory,
		{ loading: cLoading, error: cError, data: cData }
	] = useMutation(NEW_NOTE_ITEM, {
		update(caches, { data: { NewNoteCategory } }) {
			const { GetNoteCategories } = caches.readQuery({
				query: GET_LIST,
				variables: { site: site && site.id }
			});

			GetNoteCategories.docs.unshift(NewNoteCategory.doc);
			caches.writeQuery({
				query: GET_LIST,
				variables: { site: site && site.id },
				data: { GetNoteCategories }
			});
		}
	});
	//  Update Mutation
	const [
		UpdateNoteCategoryFunc,
		{ loading: uLoading, error: uError }
	] = useMutation(UPDATE_NOTE_ITEM);

	// props
	const title = "Patient Activity";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];
	const [
		removeFunc,
		{ loading: removeLoading, error: removeError }
	] = useMutation(REMOVE, {
		update(caches, { data: { DeleteNoteCategory } }) {
			const { GetNoteCategories } = caches.readQuery({
				query: GET_LIST,
				variables: { site: site && site.id }
			});

			GetNoteCategories.docs.splice(
				GetNoteCategories.docs.findIndex(
					x => x.id === DeleteNoteCategory.doc.id
				),
				1
			);
			caches.writeQuery({
				query: GET_LIST,
				variables: { site: site && site.id },
				data: { GetNoteCategories }
			});
		}
	});
	if (error && auth.authProvider.IsAuthenticationError(error.message)) {
		auth.authProvider.LogOut();
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?redirect=${location.pathname}`
				}}
			/>
		);
	}
	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />
			<div className="row justify-content-center">
				{newNote && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => setNewNote(false)}
										className="mdl-button mdl-js-button mdl-button--icon margin-right-5"
									>
										<i className="material-icons">
											arrow_back_ios
										</i>
									</button>
									New patient Activity
								</header>
							</div>
							<div className="card-body">
								<LoadingSpinner loading={cLoading} />
								<AlertMessage
									message={
										cData && cData.NewNoteCategory.message
									}
								/>
								<AlertMessage
									message={cError && cError.message}
									failed={true}
								/>
								<NewNoteCategory
									onCancel={() => setNewNote(false)}
									onSubmit={async item => {
										await CreateCategory({
											variables: {
												model: {
													site: site && site.id,
													...item
												}
											}
										});
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{noteCategory && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => setNoteCategory(null)}
										className="mdl-button mdl-js-button mdl-button--icon margin-right-5"
									>
										<i className="material-icons">
											arrow_back_ios
										</i>
									</button>
									Update Patient Activity
								</header>
							</div>
							<div className="card-body">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<UpdateNoteCategory
									onCancel={() => setNoteCategory(null)}
									currentValue={noteCategory}
									onSubmit={async ({ name, icon }) => {
										await UpdateNoteCategoryFunc({
											variables: {
												name,
												icon,
												id: noteCategory.id
											}
										});
										setNoteCategory(null);
									}}
								/>
							</div>
						</div>
					</div>
				)}
				<div className="col-md-10">
					<div className="card">
						<div className="card-head">
							<header>Patient Activities</header>
							<div className="tools">
								<button
									title="Add Patient Activity"
									onClick={() => {
										setNewNote(!newNote);
										setNoteCategory(null);
									}}
									className="mdl-button mdl-button--icon margin-right-10 btn-success"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body m-b-20">
							<LoadingSpinner
								loading={loading || removeLoading}
							/>
							<AlertMessage
								message={
									(error && error.message) ||
									(removeError && removeError.message)
								}
								failed={true}
							/>
							{!loading && (
								<ListNoteCategory
									items={data && data.GetNoteCategories.docs}
									onEdit={item => {
										setNoteCategory(item);
										setNewNote(false);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
									onRemove={async item => {
										if (
											window.confirm(
												"Are you sure you want to delete this record!"
											)
										) {
											await removeFunc({
												variables: { id: item.id }
											});
										}
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default NoteCategory;
